import NumberFlow from '@number-flow/react';

interface Props {
    title: string;
    value: number;
    unit: string;
    testId?: string;
}

const StatInfo = ({ title, value, unit, testId }: Props) => {
    return (
        <div className="ta-tile task-stats">
            <span className="label md">{title}</span>
            <div className="group-row">
                <strong className="data xxl">
                    <NumberFlow data-testid={testId} value={value} />
                </strong>
                <span className="units md">{unit}</span>
            </div>
        </div>
    );
};

export default StatInfo;
